// Lista de Turnos

import React, { useEffect, useState } from 'react';
import {
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { apiFetch, apiFetchJson } from '../fetchWrapper';


export default function ShiftTemplateList() {
  const [shiftTemplates, setShiftTemplates] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const url = `/api/shift-templates`;
    apiFetchJson(url)
      .then((data) => {
        setShiftTemplates(data || []);
        setError(null);
      })
      .catch((err) => {
        console.error('Failed to load shift templates', err);
        setError(err.message || 'Failed to load');
      })
      .finally();
  }, []);

  const handleEdit = async (template) => {
    alert('TODO: Edit shift template with id: ' + template.id);
  }

  const handleAdd = async (id) => {
    alert('TODO: Add new shift template');
  }

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">{shiftTemplates.length ? 'Plantillas de Turno' : 'No hay plantillas de turno'}</Typography>
      </Box>
      {shiftTemplates.length > 0 && (
        <TableContainer component={Paper}>
          <Table
            sx={{
              "& th, & td": {
                textAlign: "center",
              },
            }}
          >
            <TableHead
              sx={{
                backgroundColor: '#f5f5f5',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                color: '#333'
              }}>
              <TableRow>
                <TableCell>Turno</TableCell>
                <TableCell>Hora Inicio</TableCell>
                <TableCell>Hora Fin</TableCell>
                {/* <TableCell>Acciones</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {shiftTemplates.map((template) => (
                <TableRow key={template.id} hover>
                  <TableCell>{template.name}</TableCell>
                  <TableCell>{template.startTime}</TableCell>
                  <TableCell>{template.endTime}</TableCell>
                  {/* <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      sx={{ mr: 1 }}
                      onClick={() => handleEdit(template)}
                    >
                      Actualizar
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => handleDelete(template.id)}
                    >
                      Borrar
                    </Button>
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  )
}